import { StandardResult } from '@calculations/utilities/result';
import { alphaSchemas } from '@snap-types/models/auto-configurator-data-set';
import { err, ok } from 'neverthrow';
import { z } from 'zod';

type Inputs = {
  material: string;
  headStyleOptions: z.infer<typeof alphaSchemas.headStyle>;
};

export function getHeadStyleOptions({
  material,
  headStyleOptions,
}: Inputs): StandardResult<string[]> {
  const list = headStyleOptions[material];

  if (!list) {
    return err({
      message: `Head styles not found for material: ${material}`,
      context: {
        material,
        headStyleOptions,
      },
    });
  }

  return ok(list);
}
